import axios from 'axios';

const addNewProductApi = async (token, values, edit = false) => {
  try {
    let url;
    if (!edit) url = '/Product/create';
    else url = '/Product/update';

    const res = await axios.post(url, values, {
      headers: {
        lang: 'ar',
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + token
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default addNewProductApi;
